(function ($) {

    $.fn.jobsList = function(){
        
        this.each((index, element) => {
            
            const $self = $(element);
            const $jobCards = $self.find('.job-card');

            const checkMultilineTags = () => {
                $jobCards.each((i, card) => {
                    const $card = $(card);
                    const $cardTags = $card.find('.tags > span');
                    $cardTags.each((tagIndex, tag) => {
                        const $tag = $(tag);
                        // console.log('tag top offset', $tag.offset().top);
                        // console.log('tags container top offset', $tag.parent('.tags').offset().top);
                        if($tag.offset().top > $tag.parent('.tags').offset().top){
                            $tag.parent('.tags').addClass('multiline');
                        }
                    });
                });
            };

            checkMultilineTags();

            $(window).on('resize', () => {
                $jobCards.each((i, card) => {
                    $(card).find('.tags').removeClass('multiline');
                });
                checkMultilineTags();
            });

        });


        return this;
    }

    $(() => {
        $('.jobs-list').jobsList();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/modules/blocks/jobs-list.js